import React, { useEffect, useState } from 'react';

const getInitials = (name) => {
  if (!name || typeof name !== 'string') return '?';
  const words = name.trim().split(/\s+/).filter(Boolean);
  if (words.length >= 2) return `${words[0][0]}${words[1][0]}`.toUpperCase();
  return name.trim().slice(0, 2).toUpperCase();
};

/**
 * Group logo — default boxed, or bare (transparent, no container; image/initials only).
 */
const GroupLogo = ({ name, logoUrl, size = 'md', bare = false, className = '' }) => {
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    setFailed(false);
  }, [logoUrl]);

  const showImage = logoUrl && !failed;
  const sizeClass = bare ? `group-logo-bare--${size}` : `group-logo--${size}`;
  const rootClass = bare
    ? `group-logo-bare ${sizeClass} ${className}`.trim()
    : `group-logo ${sizeClass} ${className}`.trim();

  return (
    <div className={rootClass} aria-hidden>
      {showImage ? (
        <img
          src={logoUrl}
          alt=""
          className={bare ? 'group-logo-bare-img' : 'group-logo-img'}
          onError={() => setFailed(true)}
        />
      ) : (
        <span className={bare ? 'group-logo-bare-fallback' : 'group-logo-fallback'}>
          {getInitials(name)}
        </span>
      )}
    </div>
  );
};

export default GroupLogo;
